import { FC } from 'react'

import { isIFilter } from '../../helpers/isIFilter'

import { IOtherFiltersProps } from './models'

export const OtherFilters: FC<IOtherFiltersProps> = ({ filter }) => (
  <span>
    Search by "
    {filter.filters.map((el, index) => {
      if (isIFilter(el)) {
        if (index !== filter.filters.length - 1) {
          return el.value + ' | '
        }
        return el.value
      }
      return ''
    })}
    "
  </span>
)
